module.exports = __webpack_public_path__ + "img/logoRural.4dc121d6.jpg";